import React, { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, errMsg } from "@/components/email/EmParts";

export function ConsentForm({ sub, onDone }) {
  const granted = ["granted", "soft_opt_in"].includes(sub.marketing_permission);
  const [source, setSource] = useState("");
  const [evidence, setEvidence] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/email-marketing/subscribers/${sub.id}/consent`, { action: granted ? "withdraw" : "grant", source: source.trim(), evidence: evidence.trim() || null, reason: granted ? source.trim() : null });
      toast.success(granted ? "Consent withdrawn and address suppressed" : "Consent recorded");
      setSource(""); setEvidence(""); onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Card title={granted ? "Withdraw consent" : "Record consent"} testId="em-consent-form">
      <div className="space-y-2">
        <Input value={source} onChange={(e) => setSource(e.target.value)} placeholder={granted ? "Reason (e.g. customer asked by phone)" : "Source (e.g. signed consent form)"} data-testid="em-consent-source" />
        {!granted && <Input value={evidence} onChange={(e) => setEvidence(e.target.value)} placeholder="Evidence (reference, wording)" data-testid="em-consent-evidence" />}
        <Button className="w-full" variant={granted ? "destructive" : "default"} disabled={busy || source.trim().length < 2} onClick={submit} data-testid="em-consent-submit">{granted ? "Withdraw consent" : "Record consent"}</Button>
        <p className="text-[11px] text-slate-400">Every change is kept in the consent history. Withdrawing adds the email to the suppression list.</p>
      </div>
    </Card>
  );
}

export function TagEditor({ sub, manage, onDone }) {
  const [tag, setTag] = useState("");
  const save = async (tags) => {
    try { await api.patch(`/email-marketing/subscribers/${sub.id}`, { tags }); setTag(""); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  const tags = sub.tags || [];
  return (
    <Card title="Tags" testId="em-tags">
      <div className="flex flex-wrap gap-1.5 mb-3">
        {tags.map((t) => (
          <span key={t} className="inline-flex items-center gap-1 rounded-full bg-indigo-50 text-indigo-700 px-2 py-0.5 text-xs font-medium" data-testid={`em-tag-${t}`}>
            {t}{manage && <button type="button" onClick={() => save(tags.filter((x) => x !== t))} aria-label={`Remove ${t}`} data-testid={`em-tag-remove-${t}`}><X className="w-3 h-3" /></button>}
          </span>))}
        {!tags.length && <span className="text-sm text-slate-400">No tags</span>}
      </div>
      {manage && (
        <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); if (tag.trim()) save([...tags, tag.trim()]); }}>
          <Input value={tag} onChange={(e) => setTag(e.target.value)} placeholder="Add a tag" data-testid="em-tag-input" />
          <Button type="submit" variant="outline" disabled={!tag.trim()} data-testid="em-tag-add">Add</Button>
        </form>)}
    </Card>
  );
}
